import React, { Component } from 'react';
import { Theme } from '@mui/material';
import { Card, CardContent } from '@mui/material';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { createStyles, withStyles } from '@mui/styles';
import { FormType } from '../../../constants/constants';
import { resetCancellationRuleSetVersion } from '../../../reducers/cancellationRuleSetReducer';
import { RootState } from '../../../setup';
import CancellationRuleSetVersionForm from './cancellationRuleSetVersionForm';

interface IAddCancellationRuleSetVersionProps {
    classes: any;
    theme: Theme;
    match: any;
    users: any;
    steps: Array<number>;
    cancellationRuleSetId?: number;
    cancellationRuleSetVersionId?: number;
    type: FormType;
}

const styles = (theme: Theme) => createStyles({
    root: {
        width: '100%',
        marginTop: '70px',
        display: 'flex'
    },
    cardContent: {
        flex: 1,
        borderTop: '1px #ececec solid',
        borderBottom: 'none',
        marginRight: theme.spacing(5),
        marginLeft: theme.spacing(5)
    }
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    resetCancellationRuleSetVersion: () => dispatch(resetCancellationRuleSetVersion())
});

const mapStoreToProps = (store: RootState, ownProps: IAddCancellationRuleSetVersionProps) => {
    return {
        cancellationRuleSetVersionId: ownProps.match.params?.cancellationRuleSetVersionId ? Number(ownProps.match.params?.cancellationRuleSetVersionId) : undefined,
        cancellationRuleSetId: ownProps.match.params?.cancellationRuleSetId ? Number(ownProps.match.params?.cancellationRuleSetId) : undefined
    };
};

class AddCancellationRuleSetVersion extends Component<IAddCancellationRuleSetVersionProps> {
    componentWillUnmount() {
        resetCancellationRuleSetVersion();
    }

    render() {
        const { classes, steps, cancellationRuleSetVersionId, cancellationRuleSetId, type } = this.props;

        return (
            <Card className={classes.root}>
                <CardContent className={classes.cardContent}>
                    <CancellationRuleSetVersionForm cancellationRuleSetVersionId={cancellationRuleSetVersionId} cancellationRuleSetId={cancellationRuleSetId} steps={steps} type={type} />
                </CardContent>
            </Card>
        );
    }
}

export default withStyles(styles)(connect(mapStoreToProps, mapDispatchToProps)(AddCancellationRuleSetVersion));